// extracted by mini-css-extract-plugin
export default {"tupacGrid":"bq-z","tupacHeader":"cq-z","tupacHeader2":"dq-z","tupacMenu":"eq-z","tupacMenu2":"fq-z","tupacMain":"gq-z","tupacMain2":"hq-z"};